import { idCodec } from "../id/brand.js";
import { accountId as accountIdCodec, agentVersionId as agentVersionIdCodec, buildJobId as buildJobIdCodec, workspaceId as workspaceIdCodec } from "../id/codec.js";
/** The id codec of a survey question set (UUID v7, minted in the application). */
export const surveyQuestionSetIdCodec = idCodec("SurveyQuestionSetId");
/** `survey_question_set.state` (migration 0126's CHECK). */
export const SURVEY_QUESTION_SET_STATE = ["building", "ready", "failed", "archived"];
/**
 * `survey_question_set.source_kind`: how the questions arrived — typed in the console, or a file in one of the survey
 * wizard's formats (`.json`, `.csv`, `.docx`, `.md`, `.txt`; `agent-template-catalogue.ts`'s questionnaire field).
 */
export const SURVEY_QUESTION_SET_SOURCE_KIND = ["typed", "json", "csv", "docx", "md", "txt"];
/** The outbox topic of a question-set build (a FACTORY topic). */
export const SURVEY_QUESTION_SET_BUILD_TOPIC = "survey_question_set.build";
/** Thrown for a `survey_question_set.build` message whose payload is not the three ids. A producer defect. */
export class SurveyQuestionSetBuildPayloadError extends Error {
    name = "SurveyQuestionSetBuildPayloadError";
}
/** The JSON written to `outbox_message.payload` (the account and workspace are the row's own columns). */
export function surveyQuestionSetBuildWireOf(payload) {
    return {
        survey_question_set_id: payload.surveyQuestionSetId,
        agent_version_id: payload.agentVersionId,
        build_job_id: payload.buildJobId,
    };
}
/**
 * Reads a `survey_question_set.build` message back — refusing anything but the three ids, and a message with no
 * workspace (the producer always writes one).
 */
export function surveyQuestionSetBuildPayloadOf(message) {
    const payload = message.payload;
    if (typeof payload !== "object" || payload === null || Array.isArray(payload)) {
        throw new SurveyQuestionSetBuildPayloadError(`survey_question_set.build ${message.outboxMessageId} has no payload object.`);
    }
    if (message.workspaceId === null) {
        throw new SurveyQuestionSetBuildPayloadError(`survey_question_set.build ${message.outboxMessageId} names no workspace.`);
    }
    const shaped = payload;
    const read = (key, codec) => {
        const raw = shaped[key];
        if (typeof raw !== "string" || !codec.is(raw)) {
            throw new SurveyQuestionSetBuildPayloadError(`survey_question_set.build ${message.outboxMessageId} has no valid ${key}.`);
        }
        return raw;
    };
    if (!accountIdCodec.is(message.accountId) || !workspaceIdCodec.is(message.workspaceId)) {
        throw new SurveyQuestionSetBuildPayloadError(`survey_question_set.build ${message.outboxMessageId} names a malformed account or workspace.`);
    }
    return {
        kind: SURVEY_QUESTION_SET_BUILD_TOPIC,
        accountId: message.accountId,
        workspaceId: message.workspaceId,
        surveyQuestionSetId: read("survey_question_set_id", surveyQuestionSetIdCodec),
        agentVersionId: read("agent_version_id", agentVersionIdCodec),
        buildJobId: read("build_job_id", buildJobIdCodec),
    };
}
//# sourceMappingURL=survey-question-set.js.map